import React from "react";
import { Link } from "react-router";
import mobile from "../../../../public/img/mobile.png";
import email from "../../../../public/img/email.png";
import "./sticky-contact.scss";
import {
  validate2AgentTeam,
  sortByCustomDisplayOrder,
} from "../../shared/util";

const StickyLink = ({ to, children, className = "" }) => {
  if (to && to.startsWith("#")) {
    return (
      <a href={to} className={className}>
        {children}
      </a>
    );
  } else {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );
  }
};

const StickyContact = ({ entity, routes, listing }) => {
  let contactTitle = "Send Message";
  let linkHref = "/contact";
  const currentRoute = routes.slice(-1)[0];
  const currentRouteName = currentRoute && currentRoute.name;
  if (currentRouteName === "contact") return null;
  if (currentRouteName === "listing-detail" && listing) {
    const isSold = listing.status === "Sold";
    if (!isSold) contactTitle = "Request Showing";
    linkHref = "#inquire-form";
  }
  const currentEntity = entity.entityType === 1 ? "AGENT" : "TEAM";

  const isTeamAndDisplayBoth = entity && validate2AgentTeam(entity);
  let phoneNumber = entity.primaryPhone;
  if (isTeamAndDisplayBoth) {
    const teamMembers = sortByCustomDisplayOrder(
      entity.teamMembers,
      entity.siteOptions.teamMemberOptions
    );
    phoneNumber = teamMembers[0].primaryPhone;
  }

  return (
    <div className="sticky-container">
      <div className="sticky-container_desktop">
        <StickyLink to={linkHref} className="sticky-desktop-link">
          {contactTitle}
        </StickyLink>
      </div>
      <div className="sticky-container_mobile">
        <StickyLink to={linkHref} className="email">
          <div className="sticky-container_mobile-buttons">
            <img alt="" src={email}></img>
            {contactTitle}
          </div>
        </StickyLink>
        <a href={`tel:${phoneNumber}`} className="call">
          <div className="sticky-container_mobile-buttons">
            <img alt="" src={mobile}></img>
            Call {currentEntity}
          </div>
        </a>
      </div>
    </div>
  );
};

export default StickyContact;



// WEBPACK FOOTER //
// ./src/components/shared/sticky-contact/sticky-contact.js